// 群创建者
export const TEAM_GROUP_HOLDER_ROLE = 1;
// 教练
export const TEAM_COACH_ROLE = 2;
// 成员
export const TEAM_MEMBER_ROLE = 3;
